import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/icon-delete.png'
import _imports_1 from '@/assets/icon/icon-edit.png'


const _withScopeId = n => (_pushScopeId("data-v-361ee935"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-address" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, " Shipping Address ", -1))
const _hoisted_3 = {
  key: 0,
  class: "current-address"
}
const _hoisted_4 = {
  key: 1,
  class: "box-addresses"
}
const _hoisted_5 = { class: "address-content" }
const _hoisted_6 = {
  key: 0,
  class: "tag"
}
const _hoisted_7 = { class: "address-main" }
const _hoisted_8 = { class: "address-text" }
const _hoisted_9 = { class: "box-actions" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" + Add New Address ")

import { ColorVariants } from '@/constants';
  import { CheckoutStore } from '@/stores';
  import { IAddress } from '@/types/address';

  interface IProps {
    readonly?: boolean;
    store: CheckoutStore;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    readonly: { type: Boolean },
    store: null
  },
  setup(__props: any) {

const props = __props as {
    readonly?: boolean;
    store: CheckoutStore;
  }

  

  function getAddressText(address?: null | IAddress) {
    if (address) {
      return `${[address.first_name, address.last_name].join(' ')}, ${[address.country?.name, address.province?.name, address.address1, address.address2].filter(Boolean).join(',')}`;
    }
    return '';
  }

  function handleDelete(id: number) {
    props.store.deleteAddress(id);
  }


return (_ctx: any,_cache: any) => {
  const _component_AppRadio = _resolveComponent("AppRadio")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (__props.readonly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(getAddressText(__props.store.selectedAddress)), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.store.addresses, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(["card-address", { checked: item.id === __props.store.address_id }])
            }, [
              _createVNode(_component_AppRadio, {
                "model-value": item.id === __props.store.address_id,
                "onUpdate:modelValue": ($event: any) => (__props.store.selectAddress(item.id))
              }, null, 8, ["model-value", "onUpdate:modelValue"]),
              _createElementVNode("div", _hoisted_5, [
                (item.is_default)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Default Address "))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(getAddressText(item)), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: _normalizeClass([{ 'visibility-hidden': item.is_default }, "button"]),
                      onClick: ($event: any) => (handleDelete(item.id))
                    }, _hoisted_12, 10, _hoisted_10),
                    _createVNode(_component_router_link, {
                      class: "button",
                      to: { name: 'checkout.edit_shipping_address', params: { id: item.id } }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ])
              ])
            ], 2))
          }), 128)),
          _createVNode(_component_router_link, { to: { name: 'checkout.create_shipping_address' } }, {
            default: _withCtx(() => [
              _createVNode(_component_b_button, {
                class: "button-add",
                variant: _unref(ColorVariants).outlinePrimary,
                pill: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }, 8, ["variant"])
            ]),
            _: 1
          }, 8, ["to"])
        ]))
  ]))
}
}

})